/** Phase E — an ISO's or approved Agent's own downline Payout Run (not an MSC run). */
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { Card, PageHeader, StatusPill, errorText } from '../components/finance/financeUi';
import { RunsTable } from '../components/payer-runs/RunsTable';
import { RunDetail } from '../components/payer-runs/RunDetail';

function Authority({ me }) {
  if (!me) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 px-5 py-4 text-sm" data-testid="my-authority">
      <StatusPill value={me.status} testid="my-authority-status" />
      <span>Effective share {me.effective_share ?? '—'}% · max offer to your downline {me.max_downstream_offer ?? '—'}% (policy: {me.policy.min_effective_share}% minimum, {me.policy.minimum_retained_spread} points retained)</span>
      <StatusPill value={me.readiness.downline_payout_ready ? 'PAYOUT_READY' : 'NOT_PAYOUT_READY'} testid="my-payout-ready" />
    </div>
  );
}

export default function MyPayoutRunPage() {
  const [me, setMe] = useState(null);
  const [runs, setRuns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const load = useCallback(() => {
    api.request('/payer-runs/me').then(setMe).catch(() => setMe(null));
    api.request('/payer-runs/runs').then((r) => { setRuns(r); setSelected((s) => s || r[0]?.run_id || null); }).catch((e) => toast.error(errorText(e)));
  }, []);
  useEffect(load, [load]);
  useEffect(() => { if (selected) api.request(`/payer-runs/runs/${selected}`).then(setDetail).catch(() => setDetail(null)); }, [selected]);
  return (
    <div className="space-y-6" data-testid="my-payout-run-page">
      <PageHeader title="My Downline Payout Run" subtitle="What you owe your own downline from your entitlement. MSC pays you; you pay your team. Settlements are recorded here until the ACH rail is connected." />
      <Card title="Downline authority" testid="my-authority-card"><Authority me={me} /></Card>
      <Card title="My runs" testid="my-runs-card">
        <RunsTable runs={runs} selected={selected} onSelect={setSelected} />
        {detail && <div className="border-t"><RunDetail run={detail} isMsc={false} onChange={(r) => { setDetail(r); load(); }} /></div>}
      </Card>
    </div>
  );
}
